var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"channel"},[_c('PopForm',{attrs:{"popDataitem":_vm.dataForm,"themeBasic":_vm.themeBasic,"queryCondition":_vm.queryCondition,"igniteOptions":_vm.igniteOptions,"regionCode":_vm.regionCode,"routerType":_vm.routerType},on:{"clickStorename":_vm.clickStorename,"activityChanged":_vm.activityChanged}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }